import Head from 'next/head'
import React, { useContext } from 'react'
import AboutHeader from '../components/About/Header/AboutHeader'
import Metrix from '../components/About/Metrix/Metrix'
import Team from '../components/About/Team/Team'
import Values from '../components/About/Values/Values'
import CtaBand from '../components/About/CtaBand/CtaBand'
import RegisteredOffice from '../components/About/RegisteredOffice/RegisteredOffice'
import Reveal from '../components/Common/Reveal/Reveal'
import ContactForm from '../components/Common/Contact/Contact'
import Modal from '../components/Common/Modal/Modal'
import AppContext from '../context/AppContext'

const About = () => {
  const { contactForm, setContactForm }: any = useContext(AppContext)

  const leadershipTeam: any = [
    {
      linkedin: 'https://www.linkedin.com/in/sourabh-lodha-socommerz/',
      path: '/profile/sourabh.webp',
      name: 'Sourabh Lodha',
      role: 'Founder & CEO',
      maxWidth: '280px',
    },
    // {
    //   linkedin: 'https://www.linkedin.com/in/vinay-chadha-6720671a7/',
    //   path: '/profile/vinay.webp',
    //   name: 'Vinay Chadha',
    //   role: 'Co-Founder',
    //   maxWidth: '280px',
    // },
  ]

  const advisoryTeam: any = [
    {
      linkedin: null,
      path: '/profile/chandresh.webp',
      name: 'Chandresh Baid',
      role: 'Growth Leader ( IIT, IIM, PhD )',
      maxWidth: '280px',
    },
    {
      linkedin: null,
      path: '/profile/pawan.webp',
      name: 'Pawan Hora',
      role: 'Strategic Media Advisor',
      maxWidth: '280px',
    },
  ]

  const engineeringTeam: any = [
    {
      linkedin: 'https://www.linkedin.com/in/midhun-kumar-hari/',
      path: '/profile/midhun.webp',
      name: 'Midhun Kumar',
      role: 'Saas Leadership',
      maxWidth: '280px',
    },
    {
      linkedin: 'https://www.linkedin.com/in/vikas-yadav-5961a8179/',
      path: '/profile/vikash.webp',
      name: 'Vikas Yadav',
      role: 'Mobility Lead',
      maxWidth: '280px',
    },
    {
      linkedin: 'https://www.linkedin.com/in/abdhesh-kumar-656b73179/',
      path: '/profile/abdhesh.webp',
      name: 'Abdhesh Kumar',
      role: 'Cloud Leadership',
      maxWidth: '280px',
    },
  ]

  // const industryTeam: any = [
  //   {
  //     linkedin: null,
  //     path: '/profile/shiba.webp',
  //     name: 'Shiba Panda',
  //     role: 'CEO Essar',
  //     maxWidth: '280px',
  //   },
  //   // {
  //   //   linkedin: null,
  //   //   path: "/profile/rajesh.webp",
  //   //   name: "Rajesh Mohta",
  //   //   role: "CEO JSS Lifestyle",
  //   //   maxWidth: "280px"
  //   // }
  // ]

  const greekTeam: any = [
    {
      linkedin: 'https://www.linkedin.com/in/naveendudi0509/',
      path: '/profile/naveen.webp',
      name: 'Naveen Kumar',
      role: 'Chief Data Officer',
      maxWidth: '280px',
    },
    {
      linkedin: 'https://www.linkedin.com/in/paragbadala/',
      path: '/profile/parag.webp',
      name: 'Parag Badala',
      role: 'Chief Digital Transformation officer',
      maxWidth: '280px',
    },
    {
      linkedin: 'https://www.linkedin.com/in/aniruddha-banerjee21/',
      path: '/profile/aniruddha.webp',
      name: 'Aniruddha Banerjee',
      role: 'Chief Innovation Officer',
      maxWidth: '280px',
    },
  ]

  return (
    <>
      <Head>
        <title>About | Socommerz</title>
        <meta name='title' content='About | Socommerz' />
        <meta
          name='description'
          content='Sourabh Lodha, a strategic leader and advisor, is the Founder Of SoCommerz a SAAS-based headless commerce platform.'
        />
        <meta
          name='keywords'
          content='strategic leader, advisor, saas based, headless commerce platform, about socommerz'
        />
        <meta name='robots' content='index,follow' />
        <link rel='canonical' href='https://www.socommerz.com/about-us' />
        <link
          rel='alternate'
          href='https://www.socommerz.com/about-us'
          hrefLang='en-in'
        />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://www.socommerz.com/about-us/' />
        <meta property='og:title' content='About | Socommerz' />
        <meta
          property='og:description'
          content='Sourabh Lodha, a strategic leader and advisor, is the Founder Of SoCommerz a SAAS-based headless commerce platform.'
        />

        <meta
          property='twitter:url'
          content='https://www.socommerz.com/about-us/'
        />
        <meta property='twitter:title' content='About | Socommerz' />
        <meta
          property='twitter:description'
          content='Sourabh Lodha, a strategic leader and advisor, is the Founder Of SoCommerz a SAAS-based headless commerce platform.'
        />
      </Head>
      <main>
        <AboutHeader />
        <Values />
        <Reveal>
          <Team
            eyebrow='Our People'
            title='Leadership Team'
            subtitle='The vision and direction behind Socommerz.'
            teamList={leadershipTeam}
          />
        </Reveal>
        <Reveal>
          <Team
            eyebrow='Guidance'
            title='Growth Advisors'
            subtitle='Experienced operators helping us scale the right way.'
            teamList={advisoryTeam}
          />
        </Reveal>
        {/* <Team title='Industry Mentors' teamList={industryTeam} /> */}
        <Reveal>
          <Team
            eyebrow='The Core'
            title='Core Team'
            subtitle='The people driving our day-to-day momentum.'
            teamList={greekTeam}
          />
        </Reveal>
        <Reveal>
          <Team
            eyebrow='Builders'
            title='Engineering Team'
            subtitle='Shipping the platform that powers headless commerce.'
            teamList={engineeringTeam}
          />
        </Reveal>
        <Reveal>
          <Metrix />
        </Reveal>
        <Reveal>
          <CtaBand onContact={() => setContactForm(true)} />
        </Reveal>
        <Reveal>
          <RegisteredOffice />
        </Reveal>
      </main>
      {contactForm && (
        <Modal>
          <ContactForm />
        </Modal>
      )}
    </>
  )
}

export default About
